import React,{Fragment} from "react";
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import SearchIcon from '@material-ui/icons/Search';
import InputBase from '@material-ui/core/InputBase';
import Clear from "@material-ui/icons/CancelOutlined";
import { withStyles, withTheme } from "@material-ui/core/styles";
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import IndeterminateCheckBox from '@material-ui/icons/IndeterminateCheckBox';
import { getSvgIcons } from "../../../modules/Dispatch/utils/svgIcons";
import { compose } from "recompose";

const styles = theme => ({
    filterContainer:{
        padding: theme.spacing.unit,
        backgroundColor: theme.ModalBGColor,
        overflow:"hidden",
        '& label$checkbox_root$formControlLabel':{
            display:"flex",
            color: theme.TextColor
        },
        '& $searchInputRoot>$searchInput[type="text"]':{
            border:"none",
            color: theme.TextColor,
            height:24,
            '&:focus':{
                border:"none"
            },
            '&::placeholder':{
                color:theme.TextColor,
                opacity: "0.5"
            }
        }
    },
    formGroup:{
        backgroundColor: theme.ModalBGColor,
        maxWidth: 210,
        padding:"4px 8px 4px 0",
        overflowY:"auto",
        display:"flex",
        maxHeight:"150px",
        flexWrap:"nowrap"
    },
    formControlRoot:{
      margin:0,
      padding:"4px 0",
    },
    formControlLabel:{
        display:"inline-flex",
        color: theme.TextColor,
        fontSize: theme.textFontSize
    },
    checkboxRoot:{
        padding:4,
        color: theme.gridIconBorderColor
    },
    iconClass:{
        paddingRight:4,
        fontSize:16,
        color: theme.iconColor,
        display:'flex',
        alignItems:'center'
    },
    svgIconClass:{
        paddingLeft:4
    },
    optionTextClass:{
        lineHeight: "24px"
    },
    noOption:{
        padding:16,
        color: theme.TextColor
    },
    searchInputRoot:{
        fontSize: "12px",
        borderBottom:`1px solid ${theme.iconColor}`,
        width:"100%"
    },
    searchInput:{
        fontSize: "12px",
        border:"none"
    },
    searchInputFocused:{
        borderColor: theme.HeaderSelectedText,
        borderWidth: "2px"
    },
    iconStyle:{
        fontSize: "16px",
        color: theme.iconColor,
        cursor: "pointer"
    },
    labelDisabled:{
        cursor:"not-allowed"
    },
    formControlLabelDisabled:{
        color:"inherit",
        opacity:"0.5",
        pointerEvents: "none"
    },
    formControlLabelColor: {
        fontSize: "12px",
        color: theme.TextColor,
        marginTop:"5px"
    },
    checkbox_root: {
        padding: "5px",
        paddingLeft:"0px",
        verticalAlign: "middle",
        height: "100%",
        color: theme.gridIconBorderColor,
        '&$checkbox_checked': {
          color: theme.HeaderSelectedText
        }
    },
    checkbox_checked: {
    },
    checkbox_disabled:{

    },
    formLabel:{
        margin:0,
        backgroundColor: theme.ModalBGColor,
        paddingBottom: "0",
        listStyleType:"none",
        display:"flex",
        cursor:"pointer",
        paddingTop:"5px",
        '& $formControlLabelDisabled,& $checkbox_disabled':{
          color:"inherit",
          opacity:"0.5",
        }
    },
})

const StaticOptions = props => {
    const { classes } = props;
    const isSelectAllDisabled = props.options.length === 0;
    const hasSelections = props.options.some(option=>props.isOptionSelected(option.value));
    const theme = props.theme

    const getLabel = (option) => {
      return (
        <Fragment>
          {option.icon && (
            <i className={`${option.icon} ${classes.iconClass}`} />
          )}
          {option.svgIcon && (
            <div className={`${classes.iconClass} ${classes.svgIconClass}`}>
              {getSvgIcons(
                option.svgIcon,
                option?.iconStyles?.color || theme.iconColor,
                option?.iconStyles?.size
              )}
            </div>
          )}
          <span className={classes.optionTextClass}> {option.text}</span>
        </Fragment>
      );
    };
    return (
        <div className={classes.filterContainer}>
        <InputBase
            placeholder="Search…"
            classes={{
                root: classes.searchInputRoot,
                input: classes.searchInput,
                focused: classes.searchInputFocused
            }}
            value={props.searchTerm}
            onChange={(event) => props.onSearch(event.target.value)}
            endAdornment={
                <Fragment>
                    { props.searchTerm ? <Clear className={classes.iconStyle} onClick={() => props.onSearch("")}/> : ""}
                    <SearchIcon className={classes.iconStyle}/>
                </Fragment>
            }
        />

        <div className={`${isSelectAllDisabled ? classes.labelDisabled : ""}`}>
            <div onClick={()=>props.onSelectAll(!hasSelections)} className={`${classes.formLabel} ${isSelectAllDisabled ? classes.formControlLabelDisabled : ''}`}>
                <span className={`${classes.checkbox_root} ${hasSelections ? classes.checkbox_checked :'' }`}>
                    {hasSelections ?
                        <IndeterminateCheckBox color="primary"/> :
                        <CheckBoxOutlineBlankIcon />
                    }
                </span>
                <span className={classes.formControlLabelColor}>{  hasSelections ? "CLEAR ALL" : "SELECT ALL"}</span>
            </div>
        </div>

        <FormGroup className={`${classes.formGroup} customScroll`}>
            { props.options.length ? props.options.map(option => {
                const isSelected =props.isOptionSelected(option.value);
                return (
                    <FormControlLabel
                        key={option.value}
                        control={
                            <Checkbox
                                checked={isSelected}
                                color={isSelected ? "primary" :"secondary"}
                                onChange={(event) => props.onOptionSelected(option.value, event.target.checked)}
                                value={option.value}
                                classes={{
                                    root: classes.checkboxRoot
                                }}
                            />
                            }
                        label={
                            getLabel(option)
                        }
                        classes={{
                            root: classes.formControlRoot,
                            label: classes.formControlLabel
                        }}
                    />
                    )
                }) : <div className={classes.noOption}>NO OPTIONS</div>
            }
        </FormGroup>
        </div>
    )
}


export default compose(withStyles(styles),withTheme())(StaticOptions);